<div class="profile-page">
  <header class="profile-hero">
    <div class="profile-hero__inner">
      <div class="profile-hero__brand">
        <div class="profile-hero__icon" aria-hidden="true">
          <i class="pi pi-user"></i>
        </div>
        <div class="profile-hero__text">
          <span class="profile-hero__eyebrow">{{ 'USERS.PROFILE.HERO_EYEBROW' | translate }}</span>
          <h1 class="profile-hero__title">
            {{ form.get('nombres')?.value }} {{ form.get('apellidos')?.value }}
          </h1>
        </div>
      </div>
      <div class="profile-hero__meta">
        <span class="profile-hero__chip profile-hero__chip--verified">
          <i class="pi pi-check-circle" aria-hidden="true"></i>
          {{ 'USERS.PROFILE.VERIFY_BADGE' | translate }}
        </span>
        @if (!hasNoMainRole(user)) {
        <span class="profile-hero__chip">
          {{ getMainRoleLabel(user) }}
        </span>
        }
      </div>
    </div>
  </header>

  <div class="profile-mobile-bar d-lg-none">
    <button type="button" class="profile-mobile-bar__toggle" (click)="showMobileMenu = !showMobileMenu">
      <i class="pi" [ngClass]="showMobileMenu ? 'pi-times' : 'pi-bars'"></i>
      {{ 'USERS.PROFILE.MENU_MOBILE' | translate }}
    </button>
  </div>

  @if (showMobileMenu) {
  <aside class="profile-aside profile-aside--mobile d-lg-none">
    <ng-container *ngTemplateOutlet="profileSidebarContent"></ng-container>
  </aside>
  }

  <div class="profile-layout">
    <aside class="profile-aside d-none d-lg-flex">
      <ng-container *ngTemplateOutlet="profileSidebarContent"></ng-container>
    </aside>

    <div class="profile-main">
      <article class="profile-panel profile-panel--content">
      @if (activeSection === 'info') {
        <header class="profile-panel__head">
          <div class="profile-panel__icon profile-panel__icon--brand">
            <i class="pi pi-id-card"></i>
          </div>
          <div class="profile-panel__titles">
            <h2 class="profile-panel__title">{{ 'USERS.PROFILE.TITLE_PERSONAL' | translate }}</h2>
            <p class="profile-panel__desc">{{ 'USERS.PROFILE.DESC_PERSONAL' | translate }}</p>
          </div>
        </header>
        <div class="profile-panel__body">
          <form [formGroup]="form" class="profile-form p-fluid">
            <div class="row g-3">
              <div class="col-12 col-md-6">
                <p-floatLabel variant="on">
                  <input pInputText id="firstName" formControlName="nombres" class="w-100" />
                  <label for="firstName">{{ 'USERS.PROFILE.FIELD_FIRST_NAMES' | translate }}</label>
                </p-floatLabel>
              </div>
              <div class="col-12 col-md-6">
                <p-floatLabel variant="on">
                  <input pInputText id="lastName" formControlName="apellidos" class="w-100" />
                  <label for="lastName">{{ 'USERS.PROFILE.FIELD_LAST_NAMES' | translate }}</label>
                </p-floatLabel>
              </div>
              <div class="col-12 col-md-6">
                <p-floatLabel variant="on">
                  <input pInputText id="email" formControlName="email" class="w-100" readonly />
                  <label for="email">{{ 'USERS.PROFILE.FIELD_EMAIL' | translate }}</label>
                </p-floatLabel>
              </div>
              <div class="col-12 col-md-6">
                <p-floatLabel variant="on">
                  <p-select formControlName="genero" inputId="genero" [options]="generoOptions"
                    optionLabel="label" optionValue="value" class="w-100" appendTo="body"></p-select>
                  <label for="genero">{{ 'USERS.PROFILE.FIELD_GENDER' | translate }}</label>
                </p-floatLabel>
              </div>
              <div class="col-12 col-md-6">
                <p-floatLabel variant="on">
                  <input pInputText id="location" formControlName="ciudad" class="w-100" />
                  <label for="location">{{ 'USERS.PROFILE.FIELD_CITY' | translate }}</label>
                </p-floatLabel>
              </div>
              <div class="col-12 col-md-6">
                <p-floatLabel variant="on">
                  <input pInputText id="address" formControlName="direccion" class="w-100" />
                  <label for="address">{{ 'USERS.PROFILE.FIELD_ADDRESS' | translate }}</label>
                </p-floatLabel>
              </div>
              <div class="col-12 col-md-4">
                <p-floatLabel variant="on">
                  <input pInputText id="phone" formControlName="telefono" class="w-100" />
                  <label for="phone">{{ 'USERS.PROFILE.FIELD_PHONE' | translate }}</label>
                </p-floatLabel>
              </div>
              <div class="col-12 col-md-4">
                <p-floatLabel variant="on">
                  <p-datePicker inputId="birthDate" formControlName="fechaNacimiento" [showIcon]="true"
                    iconDisplay="button" [appendTo]="'body'" class="w-100 profile-datepicker"></p-datePicker>
                  <label for="birthDate">{{ 'USERS.PROFILE.FIELD_BIRTH' | translate }}</label>
                </p-floatLabel>
              </div>
              <div class="col-12 col-md-4">
                <p-floatLabel variant="on">
                  <input pInputText id="postalCode" formControlName="codigoPostal" class="w-100" />
                  <label for="postalCode">{{ 'USERS.PROFILE.FIELD_POSTAL' | translate }}</label>
                </p-floatLabel>
              </div>
            </div>
            <footer class="profile-form__actions">
              <p-button [label]="'USERS.PROFILE.BTN_DISCARD' | translate" icon="pi pi-times"
                styleClass="profile-btn profile-btn--ghost" (onClick)="discardChanges()" />
              <p-button [label]="(updatePhoto ? 'USERS.PROFILE.BTN_SAVE_WITH_PHOTO' : 'USERS.PROFILE.BTN_SAVE') | translate"
                icon="pi pi-check" styleClass="profile-btn profile-btn--primary" (onClick)="saveChanges()" />
            </footer>
          </form>
        </div>
      }

      @if (activeSection === 'password') {
        <header class="profile-panel__head">
          <div class="profile-panel__icon profile-panel__icon--accent">
            <i class="pi pi-lock"></i>
          </div>
          <div class="profile-panel__titles">
            <h2 class="profile-panel__title">{{ 'USERS.PROFILE.TITLE_PASSWORD' | translate }}</h2>
            <p class="profile-panel__desc">{{ 'USERS.PROFILE.DESC_PASSWORD' | translate }}</p>
          </div>
        </header>
        <div class="profile-panel__body">
          <form [formGroup]="passwordForm" class="profile-form profile-form--narrow p-fluid">
            <div class="row g-3 justify-content-center">
              <div class="col-12 col-md-8 col-lg-6">
                <p-floatLabel variant="on">
                  <p-password inputId="newPassword" formControlName="newPassword" [toggleMask]="true"
                    [feedback]="false" styleClass="w-100" inputStyleClass="w-100"></p-password>
                  <label for="newPassword">{{ 'USERS.PROFILE.FIELD_NEW_PASSWORD' | translate }}</label>
                </p-floatLabel>
              </div>
              <div class="col-12 col-md-8 col-lg-6">
                <p-floatLabel variant="on">
                  <p-password inputId="confirmPassword" formControlName="confirmPassword" [toggleMask]="true"
                    [feedback]="false" styleClass="w-100" inputStyleClass="w-100"></p-password>
                  <label for="confirmPassword">{{ 'USERS.PROFILE.FIELD_CONFIRM_PASSWORD' | translate }}</label>
                </p-floatLabel>
              </div>
            </div>
            <footer class="profile-form__actions profile-form__actions--center">
              <p-button [label]="'USERS.PROFILE.BTN_CANCEL' | translate" icon="pi pi-times"
                styleClass="profile-btn profile-btn--ghost" (onClick)="cancelPasswordChange()" />
              <p-button [label]="'USERS.PROFILE.BTN_CHANGE_PASSWORD' | translate" icon="pi pi-check"
                styleClass="profile-btn profile-btn--primary" (onClick)="changePassword()" />
            </footer>
          </form>
        </div>
      }
      </article>
    </div>
  </div>
</div>

<ng-template #profileSidebarContent>
  <article class="profile-panel profile-panel--sidebar">
    <div class="profile-identity">
      <div class="profile-identity__avatar-wrap">
        @if (form.get('photoUrl')?.value) {
        <p-avatar [image]="previewFotoBase64 || form.get('photoUrl')?.value" shape="circle"
          styleClass="profile-identity__avatar" (onImageError)="handleImageError()"></p-avatar>
        } @else if (previewFotoBase64 || photoUser) {
        <p-avatar shape="circle" styleClass="profile-identity__avatar"
          [image]="previewFotoBase64 || photoUser!"></p-avatar>
        } @else {
        <p-avatar shape="circle" styleClass="profile-identity__avatar profile-identity__avatar--initials">
          {{ getInitials() }}
        </p-avatar>
        }
        <button type="button" class="profile-identity__upload" (click)="fotoInput.click()"
          [pTooltip]="'USERS.PROFILE.TOOLTIP_UPLOAD' | translate" tooltipPosition="top">
          <i class="pi pi-camera" aria-hidden="true"></i>
        </button>
        <input type="file" accept="image/*" #fotoInput hidden (change)="onFotoSeleccionada($event)" />
      </div>

      <h2 class="profile-identity__name">
        {{ form.get('nombres')?.value }} {{ form.get('apellidos')?.value }}
      </h2>
      <p class="profile-identity__email">{{ form.get('email')?.value }}</p>

      <div class="profile-identity__roles">
        @if (!hasNoMainRole(user)) {
        <span class="profile-role-badge profile-role-badge--main">{{ getMainRoleLabel(user) }}</span>
        } @else {
        <span class="profile-role-badge">{{ 'USERS.MAIN_ROLE_NONE' | translate }}</span>
        }
        @if (getAccessTags(user).length > 0) {
        <div class="profile-identity__access">
          <span class="profile-identity__access-label">{{ 'USERS.ACCESS_LABEL' | translate }}</span>
          <div class="profile-identity__access-tags">
            @for (access of getAccessTags(user); track access) {
            <span class="profile-access-tag">{{ access }}</span>
            }
          </div>
        </div>
        }
      </div>
    </div>

    <nav class="profile-nav profile-nav--in-panel" role="navigation" [attr.aria-label]="'USERS.PROFILE.NAV_ARIA' | translate">
    <button type="button" class="profile-nav__item"
      [class.profile-nav__item--active]="activeSection === 'info'"
      (click)="setSection('info')">
      <span class="profile-nav__icon"><i class="pi pi-user"></i></span>
      <span>{{ 'USERS.PROFILE.NAV_PERSONAL' | translate }}</span>
    </button>
    <button type="button" class="profile-nav__item"
      [class.profile-nav__item--active]="activeSection === 'password'"
      (click)="setSection('password')">
      <span class="profile-nav__icon"><i class="pi pi-lock"></i></span>
      <span>{{ 'USERS.PROFILE.NAV_SECURITY' | translate }}</span>
    </button>
    <button type="button" class="profile-nav__item profile-nav__item--logout" (click)="logout()">
      <span class="profile-nav__icon"><i class="pi pi-sign-out"></i></span>
      <span>{{ 'USERS.PROFILE.LOGOUT' | translate }}</span>
    </button>
    </nav>
  </article>
</ng-template>

<p-toast></p-toast>
